import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../api/axios';
import toast from 'react-hot-toast';
import ViewJobCard from './ViewJobCard';

const ViewJobCardPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [jobCard, setJobCard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchJobCard();
  }, [id]);

  const fetchJobCard = async () => {
    try {
      const response = await axios.get(`/api/job-cards/${id}`);
      setJobCard(response.data);
    } catch (error) {
      toast.error('Failed to load job card');
      navigate('/all-job-cards');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!jobCard) {
    return null;
  }

  return <ViewJobCard jobCard={jobCard} onClose={() => navigate('/all-job-cards')} />;
};

export default ViewJobCardPage;
